<template>
    <div class="travel-quote-step choose-dates">
        <quote-step-header
            :title="subStepFields.title"
            :key="currentSubStep"
            :subtitle="subStepFields.subtitle"
        ></quote-step-header>
        <form class="quote-form" @submit.prevent="next">
            <div class="form-row">
                <div>
                    <app-label>{{ trans("choose_start_date") }}</app-label>
                    <app-date-input
                        icon="calendar_new"
                        v-model="form[stepName].startDate"
                        :disabled-dates="disableDepartureDate"
                    ></app-date-input>
                </div>
                <div>
                    <app-label>{{ trans("choose_end_date") }}</app-label>
                    <app-date-input
                        icon="calendar_new"
                        v-model="form[stepName].endDate"
                        :disabledDates="disableReturnDate"
                    ></app-date-input>
                </div>
            </div>

            <div class="submit-row">
                <app-button :disabled="disabledConditions" :loading="loading">
                    {{ "quote.welcome.next" | __ }}
                </app-button>
            </div>
        </form>
    </div>
</template>

<script>
import QuoteStep from "../../../mixins/QuoteStep";
import AppButton from "../../Forms/Button.vue";
export default {
    components: { AppButton },
    mixins: [QuoteStep],
    data() {
        return {
            subSteps: ["default"]
        };
    },
    computed: {
        endDate() {
            if (!this.stepFormFields.startDate) {
                return null;
            }

            return moment(this.stepFormFields.startDate)
                .add({ year: 1 })
                .endOf("month")
                .subtract({ month: 1 })
                .endOf("month")
                .set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
        },
        canMoveNext() {
            return (
                this.form[this.stepName].startDate &&
                this.form[this.stepName].endDate
            );
        },
        disableDepartureDate() {
            const today = new Date();
            const yesterday = new Date(today);
            yesterday.setDate(today.getDate() - 1);

            return {
                to: yesterday
            };
        },

        disableReturnDate() {
            return {
                to: new Date(this.stepFormFields.startDate)
            };
        }
    }
};
</script>

<style lang="scss" scoped>
.quote-form {
    .form-row {
        flex-direction: row;
        justify-content: space-between;

        > div {
            width: 45%;
        }

        .app-label-wrapper {
            margin-bottom: 10px;
        }

        @media (max-width: $tablet) {
            flex-direction: column;

            > div {
                width: 100%;
            }
        }
    }
}
</style>
